import React from "react";

/**
 * The five Y-axis icons, as React.
 *
 * The same five glyphs as `design/system/shell.js`, re-expressed rather than
 * imported: that file is a browser IIFE assigning `window.CipherShell`, it
 * lives outside `src/`, and it is a reference artefact this session does not
 * own and must not edit. Re-expressing the geometry is not porting its
 * hardcoding — C5 is about the account block, which is not here.
 *
 * `aria-hidden` on every one: the label beside the icon is the accessible name,
 * and a decorative glyph announcing itself would make each nav entry read
 * twice.
 */
const P = {
  strokeWidth: 1.6,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

function Svg({ children, size = 18 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      {...P}
    >
      {children}
    </svg>
  );
}

export const ICONS = {
  brain: (props) => (
    <Svg {...props}>
      <path d="M9 4a3 3 0 0 0-3 3 3 3 0 0 0-1 5 3 3 0 0 0 2 5 3 3 0 0 0 5 1V5a3 3 0 0 0-3-1z" />
      <path d="M15 4a3 3 0 0 1 3 3 3 3 0 0 1 1 5 3 3 0 0 1-2 5 3 3 0 0 1-5 1" />
    </Svg>
  ),
  work: (props) => (
    <Svg {...props}>
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    </Svg>
  ),
  ops: (props) => (
    <Svg {...props}>
      <path d="M4 6h16M4 12h16M4 18h10" />
      <circle cx="18" cy="18" r="2.4" />
    </Svg>
  ),
  ea: (props) => (
    <Svg {...props}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
    </Svg>
  ),
  set: (props) => (
    <Svg {...props}>
      <circle cx="12" cy="12" r="3.2" />
      <path d="M19 12a7 7 0 0 0-.1-1.2l2-1.5-2-3.4-2.3.9a7 7 0 0 0-2-1.2L14 2h-4l-.6 2.4a7 7 0 0 0-2 1.2l-2.3-.9-2 3.4 2 1.5A7 7 0 0 0 5 12c0 .4 0 .8.1 1.2l-2 1.5 2 3.4 2.3-.9a7 7 0 0 0 2 1.2L10 22h4l.6-2.4a7 7 0 0 0 2-1.2l2.3.9 2-3.4-2-1.5c.1-.4.1-.8.1-1.2z" />
    </Svg>
  ),
};

export function AreaIcon({ name, size }) {
  const Glyph = ICONS[name];
  return Glyph ? <Glyph size={size} /> : null;
}

/** The brand mark. The same glyph as the Brain icon, at brand size. */
export function BrandMark() {
  return <ICONS.brain size={15} />;
}
